<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <div>
                        <img src="@/assets/images/charging-cancel.png" alt="" />
                    </div>
                    <span>선물받는 분의 핸드폰 번호가<br>{{this.$parent.giftRequestInfo.receiverPhoneNumber}} 이(가) 맞습니까?</span>
                </div>
            </div>
            <div class="button-wrap">
              <button class="button-bg-gray border-left-round" @click="modalClose(false)">아니요</button>
              <button class="button-bg-yellow border-right-round" @click="modalClose(true)">예</button>
            </div>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'phoneNumberConfirmPopup',
    components: {BottomButton},
    data() {
        return  {
        }
    },
    methods : {
      /**
       * 선물받는분 핸드폰 번호 확인 모달 close
       * @param {boolean} confirmFlag 선물받는분의 핸드폰 번호 확인 OK 여부
       */
      modalClose(confirmFlag) {
        this.$emit('phoneNumberConfirm', confirmFlag);
      }
    }
}
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/cards/cancelChargingPopup.scss';
</style>